import React from 'react';
import * as rsuite from 'rsuite';



export function ShowMsg(type, msg) {
    return (
        rsuite.toaster.push(
            <rsuite.Message showIcon  type={type} closable>
                {msg}
            </rsuite.Message>, { placement: 'bottomStart',duration:30000 })
    );
}

export function GuidEmpty() {
    return (
      '00000000-0000-0000-0000-000000000000'
    );
}


export function ApiRoute() {
        // return "http://localhost:20232/api";
       return "https://api.TicketLAB.ir/api";
};

// پیوست های گفتگوی وظایف - پوشه ای جدا از پیوست تیکت ها که روی /files است
export function TaskFileRoute() {
    return ApiRoute().replace("/api", "") + "/taskfiles/";
};

// نشان گفتگوهای باز در نوار بالای صفحه است، ولی چیزی که عدد را عوض می کند
// داخل خود صفحه ها اتفاق می افتد. به جای رد کردن یک تابع از چند لایه، هر
// صفحه ای که وضعیت گفتگوها را عوض یا بازخوانی می کند این رویداد را می فرستد
// و قاب Shared به آن گوش می دهد.
export const ChatCountEvent = "ticketlab-chatcount";

export function RefreshChatCount() {
    window.dispatchEvent(new Event(ChatCountEvent));
}

export const RowNumber = ({ rowIndex, ...props }) => (

  <rsuite.Table.Cell {...props}>
    {rowIndex + 1}
  </rsuite.Table.Cell>
);

//#region Msg

export function UnkownException(error) {
    return (
      'خطای ناشناخته رخ داده است ، شــرح خطا : '+error
    );
}
export function SaveSuccess() {
    return (
            'اطلاعات با موفقیت ذخیره سازی شد'
    );
}

export function DeleteSuccess(){
  return "اطلاعات با موفقیت حذف شد"
}
export function DeleteError(){
  return "خطا در حذف اطلاعات رخ داده است"
}

export function unAuthorize() {
    return (
      'لطفاً مجدداً وارد نرم افزار شوید'
    );
}

export function AccessDenied() {
    return (
      'دسترسی شما به این عملیات محدود می باشد'
    );
}
//#endregion 
